var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarRepositorioHover68X56(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 58,
    viewBox: "0 0 68 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5345_57362)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1299 23.8696C25.4441 23.8696 24.8799 24.4338 24.8799 25.1196V34.6896C24.8799 35.3754 25.4441 35.9396 26.1299 35.9396H38.0699C38.1046 35.9396 38.1393 35.942 38.1735 35.9468C38.8209 35.9032 39.3399 35.3573 39.3399 34.6996V27.2096C39.3399 26.5238 38.7757 25.9596 38.0899 25.9596H31.8999C31.4521 25.9596 31.038 25.7825 30.7316 25.5101L30.729 25.5078L28.9798 23.9385C28.9797 23.9384 28.9799 23.9386 28.9798 23.9385C28.9226 23.8874 28.869 23.8696 28.8099 23.8696H26.1299ZM23.3799 25.1196C23.3799 23.6054 24.6157 22.3696 26.1299 22.3696H28.8099C29.2507 22.3696 29.6572 22.5319 29.98 22.8206L29.9807 22.8213L31.729 24.3898C31.7825 24.4369 31.8479 24.4596 31.8999 24.4596H38.0899C39.6041 24.4596 40.8399 25.6954 40.8399 27.2096V34.6996C40.8399 36.2138 39.6041 37.4496 38.0899 37.4496C38.0489 37.4496 38.008 37.4462 37.9678 37.4396H26.1299C24.6157 37.4396 23.3799 36.2038 23.3799 34.6896V25.1196Z",
    fill: "#61B09D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7299 20.0596C29.1541 20.0596 28.6799 20.5338 28.6799 21.1096C28.6799 21.5238 28.3441 21.8596 27.9299 21.8596C27.5157 21.8596 27.1799 21.5238 27.1799 21.1096C27.1799 19.7054 28.3257 18.5596 29.7299 18.5596H32.6099C33.0507 18.5596 33.4572 18.7219 33.78 19.0106L33.7807 19.0113L35.529 20.5798C35.5825 20.6269 35.6479 20.6496 35.6999 20.6496H42.0899C43.4941 20.6496 44.6399 21.7954 44.6399 23.1996V31.0896C44.6399 32.4938 43.4941 33.6396 42.0899 33.6396C41.6757 33.6396 41.3399 33.3038 41.3399 32.8896C41.3399 32.4754 41.6757 32.1396 42.0899 32.1396C42.6657 32.1396 43.1399 31.6654 43.1399 31.0896V23.1996C43.1399 22.6238 42.6657 22.1496 42.0899 22.1496H35.6999C35.2521 22.1496 34.838 21.9725 34.5316 21.7001L34.529 21.6978L32.7798 20.1285C32.7797 20.1284 32.7799 20.1286 32.7798 20.1285C32.7226 20.0774 32.669 20.0596 32.6099 20.0596H29.7299Z",
    fill: "#61B09D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3799 33.6896C26.3799 33.2754 26.7157 32.9396 27.1299 32.9396H29.9499C30.3641 32.9396 30.6999 33.2754 30.6999 33.6896C30.6999 34.1038 30.3641 34.4396 29.9499 34.4396H27.1299C26.7157 34.4396 26.3799 34.1038 26.3799 33.6896Z",
    fill: "#61B09D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5345_57362",
    x: -14,
    y: -10,
    width: 96,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.278431 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5345_57362"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5345_57362",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarRepositorioHover68X56);
export default __webpack_public_path__ + "static/media/SIDEBAR-REPOSITORIO-HOVER_68X56.a10f8a7475251681c1227b9eb313ae77.svg";
export { ForwardRef as ReactComponent };